import { apiHelper } from '@/utils'
import { API } from '@/constants'

const API_URL = API.BASE_URL + '/v1'

export const documentSignatureService = {
  generateSigningLink,
  listByDocument,
  verifyToken,
  submitSignature,
  selectSigningOptions,
  getInlineSignatures,
  saveInlineSignatures,
}

export function getInlineSignatures(docType, docNo) {
  return apiHelper(API_URL).get(`/document-signatures/${docType}/${docNo}/inline`)
}
export function saveInlineSignatures(docType, docNo, data) {
  return apiHelper(API_URL).post(`/document-signatures/${docType}/${docNo}/inline`, data)
}

export function generateSigningLink(data) {
  return apiHelper(API_URL).post('/document-signatures/generate-link', data)
}
export function listByDocument(docType, docNo) {
  return apiHelper(API_URL).get(`/document-signatures/${docType}/${docNo}`)
}
export function verifyToken(token) {
  return apiHelper(API_URL).get(`/signing/${token}/verify`)
}
/** Customer-side pick of alternative offers; answers the same payload as verify. */
export function selectSigningOptions(token, selections) {
  return apiHelper(API_URL).post(`/signing/${token}/select-options`, { selections })
}
export function submitSignature(token, signature_data, signer_name, selections) {
  const body = { signature_data, signer_name }
  if (Array.isArray(selections) && selections.length) body.selections = selections
  return apiHelper(API_URL).post(`/signing/${token}/submit`, body)
}
